import React from 'react';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';
import RemotasksExternalLink from 'react-scale/corp/components/UI/RemotasksExternalLink';
import { Table, TableColumn } from '@scale/scaleui';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';

import { LookupIdLink } from '../common';

type SubstageInstanceSubmissionsPanelProps = {
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const TABLE_COLUMNS: TableColumn[] = [
  {
    id: 'taskAttempt',
    header: 'Task Attempt',
    cell: function taskAttempt(props: { row?: { original?: { taskAttempt?: string } } }) {
      const attempt = props?.row?.original?.taskAttempt;
      if (attempt) {
        return <LookupIdLink className="inline-block" id={attempt} />;
      } else {
        return 'N/a';
      }
    },
  },
  {
    id: 'humanNode',
    header: 'Human Node',
    cell: function humanNodeCell(props: { row?: { original?: { humanNode?: string } } }) {
      const humanNode = props?.row?.original?.humanNode;
      if (humanNode) {
        return <LookupIdLink className="inline-block" id={humanNode} />;
      } else {
        return 'N/a';
      }
    },
  },
  {
    id: 'reviewLevel',
    header: 'Review Level',
  },
  {
    id: 'reviewOutcome',
    header: 'Review Outcome',
    cell: function reviewOutcomeCell(props: { row?: { original?: { reviewOutcome?: string } } }) {
      return <text>{props?.row?.original?.reviewOutcome ?? 'n/a'}</text>;
    },
  },
  {
    id: 'user',
    header: 'User',
    cell: function userCell(props: { row?: { original?: { user?: string } } }) {
      const user = props?.row?.original?.user;
      if (user) {
        return <LookupIdLink className="inline-block" id={user} />;
      } else {
        return 'N/a';
      }
    },
  },
  {
    id: 'submissionTime',
    header: 'Submission Time',
  },
  {
    id: 'timeSpent',
    header: 'Time Spent',
  },
  {
    id: 'activeTimeSpent',
    header: 'Active Time Spent',
  },
  {
    id: 'humanNode',
    header: 'Response',
    cell: function responseCell(props: { row?: { original?: { humanNode?: string } } }) {
      const humanNode = props?.row?.original?.humanNode;
      if (humanNode) {
        return (
          <RemotasksExternalLink path="/lidarlite" query={{ sceneId: humanNode, readOnly: 1 }}>
            View in LL
          </RemotasksExternalLink>
        );
      }
    },
  },
];

const SubstageInstanceSubmissionPanel = ({
  substageInstance,
}: SubstageInstanceSubmissionsPanelProps) => {
  if (!substageInstance.submissionLog) return null;

  return (
    <HideableSection name="Submission Log">
      <Table data={substageInstance.submissionLog} columns={TABLE_COLUMNS} manualPagination />
    </HideableSection>
  );
};

export default SubstageInstanceSubmissionPanel;
